export const VAR_MODE = 'furi-mode'
export const VAR_STRING = 'furi-string'
